export const Config = {
  basePath: 'http://116.62.205.12:5008',
  // basePath: 'http://localhost:5008',
  ossPrefix: 'https://scs-official.oss-cn-hangzhou.aliyuncs.com',
  version: '1.0.0',
};
